<template>
    <div class="viewToggle">
        <div class="inputs">
            <input type="radio" name="viewBy" id="viewByDay" v-model="toggled" value="0">
            <input type="radio" name="viewBy" id="viewByMovie" v-model="toggled" value="1">
        </div>
        <label for="viewByDay">View by day</label>
        <span
            v-bind:class="{toggleWrapper: true, toggled: Number(toggled) === 1}"
            v-on:click="doToggle"
        >
            <span
                class="toggleCore"
            ></span>
        </span>
        <label for="viewByMovie">View by movie</label>
    </div>
</template>

<script>
    export default {
        props: ['value'],
        data: function() {
            return {
                toggled: false,
            }
        },
        watch: {
            toggled: function() {
                this.notify();
            }
        },
        methods: {
            doToggle: function() {
                this.toggled = 1 - this.toggled;
            },
            notify: function() {
                this.$emit('input', Number(this.toggled) === 1);
            }
        },
    }
</script>

<style>
    .viewToggle {
        font-size: 0;
    }
    label {
        font-size: 12pt;
    }
    .inputs {
        display: inline-block;
        height: 1px;
        width: 1px;
        opacity: 0;
        overflow: hidden;
    }
    .toggleWrapper {
        display: inline-block;
        width: 45px;
        height: 22px;
        background-color: #e0a55f;
        border-radius: 11px;
        position: relative;
        transition: background-color 0.2s linear;
        vertical-align: top;
        margin: 0 15px 0 12px;
    }

    .toggleCore {
        display: inline-block;
        width: 16px;
        height: 16px;
        background: white;
        margin: 3px;
        border-radius: 8px;
        position: absolute;
        transition: transform 0.1s linear;
    }

    .toggled {
        background-color: #698291;
    }

    .toggled .toggleCore {
        transform: translateX(23px);
    }
</style>